export default __webpack_public_path__ + "static/media/England-vs-Croatia.765b24b3.jpeg";